import { api } from "../api";
import axios from "axios";


export const getPhases= async () => {
    const res = await axios.get(api+'phases/', {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
}});
    return res.data;
}

export const getPhasesE= async () => {
    const res = await axios.get(api+'phasesE/', {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
}});
    return res.data;
}

export const addPhase= async(titre,description) => {
    await axios.post(api+'phases',{
        titre: titre,
        description: description
    }, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data' ,
            Accept: "application/json",
}});
}



export const deletePhase = async (phaseId) => {
    await axios.delete(api+'phases/'+phaseId , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data' ,
            Accept: "application/json",
}});
}
